import React from "react";

export default ({ className, name, label, required, children }) => (
  <div className={`relative ${className || "w-full md:w-1/2"}`}>
    <label for={name} className="field-label">
      {label}
    </label>
    <select
      id={name}
      name={name}
      required={!!required}
      className="field-select"
    >
      {children}
    </select>
    <div
      style={{ bottom: "1.8em", right: "1.5em" }}
      class="pointer-events-none absolute flex items-center px-2 text-navy-p1"
    >
      <svg
        class="fill-current h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
      </svg>
    </div>
  </div>
);
